<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <span v-on="on" class="caption" v-if="codigoInterno">
        <b>#</b>{{ codigoInterno }} -
      </span>
    </template>
    <span>Código interno</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    codigoInterno: {
      type: String,
    },
  },
};
</script>
